(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tamra-delivery"] && !Shopify.designMode) return;
  try {
    (() => {
  function initDelivery() {
    document.querySelectorAll('[data-tamra-delivery]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const select = root.querySelector('[data-delivery-country]');
      const labels = JSON.parse(root.querySelector('[data-delivery-strings]').textContent);
      const maxDays = {NZ:8, AU:8, US:8, CA:8, GB:8};
      if (maxDays[root.dataset.country]) select.value = root.dataset.country;
      function dayNZ() {
        const parts = new Intl.DateTimeFormat('en-CA',{timeZone:'Pacific/Auckland',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
        const value = name => parts.find(p=>p.type===name).value;
        return new Date(Date.UTC(Number(value('year')),Number(value('month'))-1,Number(value('day')),12));
      }
      function addBusinessDays(date, days) {
        const result = new Date(date);
        while (days > 0) { result.setUTCDate(result.getUTCDate()+1); if (result.getUTCDay()!==0 && result.getUTCDay()!==6) days--; }
        return result;
      }
      function update() {
        const date = dayNZ();
        const format = d => new Intl.DateTimeFormat(document.documentElement.lang || 'en-NZ',{timeZone:'UTC',day:'numeric',month:'short'}).format(d);
        const max = maxDays[select.value] || 8;
        root.querySelector('[data-order-day]').textContent = format(date);
        root.querySelector('[data-transit-days]').textContent = `Up to ${max} ${labels.business} ${labels.after}`;
        root.querySelector('[data-delivery-range]').textContent = `by ${format(addBusinessDays(date,max))}`;
      }
      select.addEventListener('change',update);
      document.addEventListener('visibilitychange',()=>{ if (!document.hidden) update(); });
      update();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initDelivery);else initDelivery();
  document.addEventListener('shopify:section:load',initDelivery);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tamra-design"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.tamraRefinedReady) return;
  window.tamraRefinedReady = true;
  const start = () => {
    const ui = JSON.parse(document.getElementById('TamraUI')?.textContent || '{}');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const reveal = (root = document) => {
      if (reduced.matches || !('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      }), { threshold: 0.07, rootMargin: '0px 0px 25px 0px' });
      root.querySelectorAll('[data-tr-reveal]:not(.tr-reveal-ready)').forEach(el => { el.classList.add('tr-reveal-ready'); observer.observe(el); });
    };
    reveal();
    document.addEventListener('shopify:section:load', event => { reveal(event.target); initProducts(event.target); });
    const depth = document.querySelector('[data-tr-depth]');
    if (depth && !reduced.matches && window.matchMedia('(pointer: fine)').matches) {
      const visual = depth.parentElement;
      visual.addEventListener('pointermove', event => {
        const rect = visual.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width - .5) * 8;
        const y = ((event.clientY - rect.top) / rect.height - .5) * 8;
        depth.style.transform = `translate(${x}px, ${y}px) scale(1.018)`;
      });
      visual.addEventListener('pointerleave', () => { depth.style.transform = ''; });
    }
    document.querySelectorAll('.tr-mobile-menu').forEach(menu => {
      menu.addEventListener('click', event => { if (event.target.closest('a')) menu.open = false; });
      menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
    });
    const initProducts = (scope = document) => {
      scope.querySelectorAll('[data-tr-product]').forEach(root => {
        if (root.dataset.trBound) return;
        root.dataset.trBound = 'true';
        const form = root.querySelector('.tr-product-form');
        const status = root.querySelector('[data-tr-cart-status]');
        const viewBag = root.querySelector('[data-tr-view-bag]');
        const addButtons = Array.from(root.querySelectorAll('[data-tr-add]'));
        let busy = false;
        const selected = () => root.querySelector('[data-tr-variant]:checked');
        const syncVariant = () => {
          const variant = selected();
          if (!variant) return;
          root.querySelectorAll('[data-tr-price]').forEach(el => { el.textContent = variant.dataset.price; });
          root.querySelectorAll('[data-tr-regular]').forEach(el => { el.textContent = variant.dataset.regular; });
          root.querySelectorAll('[data-tr-selected-size]').forEach(el => { el.textContent = variant.dataset.title; });
          const available = variant.dataset.available === 'true';
          addButtons.forEach(button => { button.disabled = !available || busy; });
          root.querySelectorAll('[data-tr-add-label]').forEach(el => { el.textContent = busy ? ui.adding : available ? ui.add : ui.sold; });
          root.querySelector('[data-tr-stock]').textContent = available ? ui.stock : ui.sold;
        };
        form?.addEventListener('change', event => {
          if (!event.target.matches('[data-tr-variant]')) return;
          syncVariant();
          status.textContent = '';
          const url = new URL(location.href);
          url.searchParams.set('variant', event.target.value);
          history.replaceState({}, '', url);
        });
        form?.addEventListener('submit', async event => {
          event.preventDefault();
          if (busy || !form.reportValidity() || selected()?.dataset.available !== 'true') return;
          busy = true;
          syncVariant();
          form.setAttribute('aria-busy', 'true');
          status.textContent = ui.adding;
          viewBag.hidden = true;
          const formData = new FormData(form);
          try {
            const response = await fetch(ui.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
            const result = await response.json();
            if (!response.ok) {
              status.textContent = typeof result.description === 'string' ? result.description : ui.failed;
              viewBag.hidden = false;
            } else {
              status.textContent = ui.added;
              viewBag.hidden = false;
              const countResponse = await fetch(ui.cart, { headers: { Accept: 'application/json' } });
              if (countResponse.ok) {
                const cart = await countResponse.json();
                document.querySelectorAll('[data-tr-cart-count]').forEach(el => { el.textContent = String(cart.item_count); });
              }
            }
          } catch {
            status.textContent = ui.failed;
            viewBag.hidden = false;
          } finally {
            busy = false;
            form.removeAttribute('aria-busy');
            syncVariant();
          }
        });
        const mainImage = root.querySelector('.tr-gallery-main img');
        root.querySelectorAll('[data-tr-thumb]').forEach(button => button.addEventListener('click', () => {
          const image = button.querySelector('img');
          if (!image || !mainImage) return;
          mainImage.src = image.src;
          mainImage.srcset = image.srcset;
          mainImage.alt = image.alt;
          mainImage.sizes = '(min-width: 900px) 50vw, 100vw';
          root.querySelectorAll('[data-tr-thumb]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          if (!reduced.matches) mainImage.animate([{ opacity: .45, transform: 'scale(1.02)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 320, easing: 'ease-out' });
        }));
        const zoom = root.querySelector('[data-tr-zoom-dialog]');
        const zoomButton = root.querySelector('[data-tr-zoom]');
        zoomButton?.addEventListener('click', () => {
          if (!mainImage || !zoom) return;
          const image = zoom.querySelector('img');
          image.src = mainImage.src;
          image.srcset = mainImage.srcset;
          image.sizes = '90vw';
          image.alt = mainImage.alt;
          zoom.showModal();
        });
        zoom?.querySelector('[data-tr-close-zoom]').addEventListener('click', () => zoom.close());
        zoom?.addEventListener('click', event => { if (event.target === zoom) zoom.close(); });
        zoom?.addEventListener('close', () => zoomButton.focus());
        const sticky = root.querySelector('[data-tr-sticky]');
        if ('IntersectionObserver' in window && form && sticky) {
          const observer = new IntersectionObserver(entries => {
            const entry = entries[0];
            sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
          }, { threshold: 0 });
          observer.observe(form);
        }
        syncVariant();
      });
    };
    initProducts();
    const guide = document.querySelector('[data-tr-guide]');
    if (!guide) return;
    const dialog = guide.querySelector('dialog');
    const data = JSON.parse(guide.querySelector('[data-tr-guide-data]').textContent);
    const t = data.text;
    const log = guide.querySelector('[data-tr-guide-log]');
    const choices = guide.querySelector('[data-tr-guide-choices]');
    let opener;
    let scores = [0, 0, 0];
    let activeStep = 'home';
    const say = (message, user = false) => {
      const bubble = document.createElement('div');
      bubble.className = 'tr-chat-bubble' + (user ? ' is-user' : '');
      bubble.textContent = message;
      log.append(bubble);
      log.scrollTop = log.scrollHeight;
    };
    const clearChoices = () => { choices.replaceChildren(); };
    const choice = (label, handler) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = label;
      button.addEventListener('click', () => { clearChoices(); say(label, true); handler(); choices.querySelector('button,a')?.focus({ preventScroll: true }); });
      choices.append(button);
    };
    const link = (label, href) => {
      if (!href) return;
      const anchor = document.createElement('a');
      anchor.textContent = label;
      anchor.href = href;
      choices.append(anchor);
    };
    const more = () => choice(t.more, home);
    const home = () => {
      activeStep = 'home';
      clearChoices();
      say(t.hello);
      choice(t.quiz, question1);
      choice(t.care, () => { say(t.careAnswer); link(t.care, data.productUrl + '#care'); more(); });
      choice(t.shipping, () => { say(t.shippingAnswer); link(t.delivery, data.shippingUrl); link(t.guarantee, data.refundUrl); more(); });
      choice(t.contact, () => { say(t.contactAnswer); link(t.contact, 'mailto:info@tamrabottle.com'); more(); });
    };
    const question1 = () => {
      activeStep = 'quiz';
      scores = [0, 0, 0];
      say(t.q1);
      [t.bag, t.desk, t.out].forEach((label, index) => choice(label, () => { scores[index] += 2; question2(); }));
    };
    const question2 = () => {
      say(t.q2);
      [t.compact, t.balance, t.room].forEach((label, index) => choice(label, () => { scores[index] += 4; question3(); }));
    };
    const question3 = () => {
      say(t.q3);
      choice(t.plain, recommend);
      choice(t.other, () => { say(t.unsuitable); choice(t.switch, recommend); choice(t.care, () => { say(t.careAnswer); more(); }); more(); });
    };
    const recommend = () => {
      activeStep = 'result';
      const index = scores.indexOf(Math.max(...scores));
      const titles = ['500ml', '750ml', '1L'];
      const variant = data.variants.find(item => item.title.toLowerCase() === titles[index].toLowerCase());
      const reasons = [t.reason500, t.reason750, t.reason1000];
      if (!variant) { say(t.unavailable); link(t.shop, data.productUrl); more(); return; }
      say(t.recommend + '\n\n' + variant.title + ' · ' + variant.price + '\n' + reasons[index]);
      if (variant.available) link(t.shop + ' ' + variant.title, data.productUrl + '?variant=' + variant.id);
      else { say(t.unavailable); link(t.shop, data.productUrl); }
      choice(t.care, () => { say(t.careAnswer); more(); });
      more();
    };
    guide.querySelector('[data-tr-guide-reset]').addEventListener('click', () => { log.replaceChildren(); home(); choices.querySelector('button')?.focus(); });
    guide.querySelector('[data-tr-close-guide]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => opener?.focus({ preventScroll: true }));
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-tr-open-guide]');
      if (!button) return;
      opener = button;
      if (!log.children.length) home();
      dialog.showModal();
      choices.querySelector('button,a')?.focus({ preventScroll: true });
    });
    guide.querySelector('.tr-guide-launcher').hidden = false;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tamra-review-rotator"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.tamraRotatorReady) return;
  window.tamraRotatorReady = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const clean = (el) => (el ? el.textContent.replace(/\s+/g, ' ').trim() : '');

  const readReviews = () => {
    const seen = new Set();
    const list = [];
    document.querySelectorAll('.jdgm-review-widget .jdgm-rev, .jdgm-rev-widg .jdgm-rev').forEach((rev) => {
      const body = clean(rev.querySelector('.jdgm-rev__body'));
      const name = clean(rev.querySelector('.jdgm-rev__author'));
      if (!body || seen.has(name + body)) return;
      seen.add(name + body);
      const scoreEl = rev.querySelector('.jdgm-rev__rating');
      const score = Math.max(1, Math.min(5, Math.round(parseFloat(scoreEl && scoreEl.getAttribute('data-score')) || 5)));
      const pic = rev.querySelector('.jdgm-rev__pics img, .jdgm-rev__pic-img');
      list.push({
        name: name || 'Tamra customer',
        body: body.length > 150 ? body.slice(0, 147).replace(/\s+\S*$/, '') + '…' : body,
        score,
        verified: !!rev.querySelector('.jdgm-rev__buyer-badge'),
        photo: pic ? (pic.getAttribute('data-src') || pic.getAttribute('src') || '') : ''
      });
    });
    return list;
  };

  const buildCard = (r) => {
    const fig = document.createElement('figure');
    fig.className = 'tr-rot-card';
    const av = document.createElement('span');
    av.className = 'tr-rot-avatar';
    av.setAttribute('aria-hidden', 'true');
    if (r.photo && /^https?:|^\/\//.test(r.photo)) {
      const img = document.createElement('img');
      img.src = r.photo; img.alt = ''; img.loading = 'lazy';
      av.append(img);
    } else {
      av.textContent = r.name.charAt(0).toUpperCase();
    }
    const box = document.createElement('div');
    const head = document.createElement('p');
    head.className = 'tr-rot-head';
    const who = document.createElement('strong');
    who.textContent = r.name;
    head.append(who);
    if (r.verified) {
      const v = document.createElement('span');
      v.className = 'tr-rot-verified';
      v.textContent = '✓ Verified';
      head.append(v);
    }
    const stars = document.createElement('span');
    stars.className = 'tr-rot-stars';
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', 'Rated ' + r.score + ' out of 5');
    stars.textContent = '★★★★★'.slice(0, r.score) + '☆☆☆☆☆'.slice(0, 5 - r.score);
    head.append(stars);
    const q = document.createElement('blockquote');
    q.textContent = r.body;
    box.append(head, q);
    fig.append(av, box);
    return fig;
  };

  const mount = (root, reviews) => {
    if (!reviews.length || root.dataset.trMounted) return;
    root.dataset.trMounted = 'true';
    const stage = root.querySelector('[data-tr-rot-stage]');
    const cards = reviews.slice(0, 12).map(buildCard);
    cards.forEach((c) => stage.append(c));
    let i = 0, timer = null, paused = false;
    const show = (n) => {
      i = (n + cards.length) % cards.length;
      cards.forEach((c, k) => { c.classList.toggle('is-active', k === i); c.setAttribute('aria-hidden', String(k !== i)); });
    };
    const ms = Math.max(2, parseFloat(root.dataset.interval) || 4) * 1000;
    const start = () => { stop(); if (cards.length > 1 && !paused && !reduced.matches && !document.hidden) timer = setInterval(() => show(i + 1), ms); };
    const stop = () => { if (timer) clearInterval(timer); timer = null; };
    root.querySelector('[data-tr-rot-prev]').addEventListener('click', () => { show(i - 1); start(); });
    root.querySelector('[data-tr-rot-next]').addEventListener('click', () => { show(i + 1); start(); });
    root.addEventListener('mouseenter', () => { paused = true; stop(); });
    root.addEventListener('mouseleave', () => { paused = false; start(); });
    root.addEventListener('focusin', () => { paused = true; stop(); });
    root.addEventListener('focusout', () => { paused = false; start(); });
    document.addEventListener('visibilitychange', start);
    root.classList.toggle('is-single', cards.length < 2);
    show(0);
    root.hidden = false;
    start();
  };

  const init = () => {
    const roots = document.querySelectorAll('[data-tr-rotator]');
    if (!roots.length) return;
    const tryMount = () => {
      const reviews = readReviews();
      if (reviews.length) { roots.forEach((r) => mount(r, reviews)); return true; }
      return false;
    };
    if (tryMount()) return;
    // Judge.me fills its widget after the page loads; watch for the reviews to arrive.
    const obs = new MutationObserver(() => { if (tryMount()) obs.disconnect(); });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => obs.disconnect(), 20000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

})();
